<div class="main-container">
  <div class="mdl-container">
    <div
      class="d-grid mdl-header"
      style="padding-bottom: 10px; margin-bottom: 20px"
    >
      <div class="center-svg">
        <img src="assets/svg/money-icon.svg" alt="" />
      </div>
      <div><h4 class="text-semibold">Agregar Productos</h4></div>
      <div>
        <h3 class="color-gray text-semibold">
          <div class="center-svg">
            <img
              (click)="closeMdl();"
              class="close-button"
              src="assets/svg/close-icon.svg"
              alt=""
            />
          </div>
        </h3>
      </div>
    </div>

    <div class="mdl-body">
    @if(internal_loading) {
      <div class="spinner-container">
        <div class="spinner"></div>
      </div>
    }@else {
    <form>
        <div>
          <div
            class="npt-table-search-bar d-grid"
            style="padding-top: 10px; margin-bottom: 20px"
          >
            <div><img src="assets/svg/search.svg" alt="" /></div>
            <input
              type="text"
              name="searchTerm"
              class="npt-nav-search"
              placeholder="Buscar por nombre, descripción o part number..."
              [(ngModel)]="searchTerm"
              (input)="onSearchChange()"
            />
          </div>
          
          <!-- Indicador de resultados -->
          @if (searchTerm.trim()) {
            <div class="search-results-info">
              <small>
                Se encontraron <strong>{{ filteredProducts.length }}</strong> 
                producto{{ filteredProducts.length !== 1 ? 's' : '' }} 
                que coinciden con "{{ searchTerm }}"
              </small>
            </div>
          }
          <div class="prospectos-table" style="margin-top: 20px">
            <table>
              <thead>
                <tr>
                  <th class="checkbox-column text-center">
                    <img src="assets/svg/checkline-icon.svg" />
                  </th>
                  <th>Nombre del producto</th>
                  <th>Part number</th>
                  <!-- <th>Precio de lista</th> -->
                  <th>Descripcion del producto</th>
                  <th>Familia de productos</th>
                  <th>Sub-familia</th>
                </tr>
              </thead>
              <tbody>
                @for (product of filteredProducts; track product) {
                <tr>
                  <td class="checkbox-column">
                    <input
                      [value]="product.codigo_prod"
                      type="checkbox"
                      [checked]="isSelected(product)"
                      (click)="$event.stopPropagation()"
                      (change)="toggleSelection(product)"
                    />
                  </td>
                  <td>{{ product.nombre }}</td>
                  <td>{{ product.partnum }}</td>
                  <!-- <td>CLP {{ product.precio_lista | number:'1.0-0' }}</td> -->
                  <td>{{ product.descripcion }}</td>
                  <td>{{ product.familia }}</td>
                  <td>{{ product.subfamilia }}</td>
                </tr>
                }
                
                <!-- Mensaje cuando no hay resultados -->
                @if (filteredProducts.length === 0 && searchTerm.trim()) {
                <tr>
                  <td colspan="6" class="text-center no-results">
                    <div class="no-results-content">
                      <img src="assets/svg/search.svg" alt="Sin resultados" class="no-results-icon">
                      <p>No se encontraron productos que coincidan con "<strong>{{ searchTerm }}</strong>"</p>
                      <small>Intenta buscar por nombre, descripción o part number</small>
                    </div>
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </form>

    }
    </div>
          <div class="mdl-footer d-flex flex-row justify-center gap-20 mt-2">
        <button class="btn btn-primary-outline text-center" (click)="closeMdl()">
          Cancelar
        </button>
        <button class="btn btn-primary text-center" (click)="saveProducts()">
          Guardar nuevo presupuesto
        </button>
      </div>
  </div>
</div>
